// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement, Component, PropTypes } from '@plesk/ui-library';
import classnames from 'classnames';

class Flipper extends Component {
    constructor() {
        super();

        this.state = {
            flipped: false,
        };
    }

    handleFlip = () => {
        this.setState({
            flipped: !this.state.flipped,
        });
    };

    render() {
        const { className, front, back } = this.props;
        const { flipped } = this.state;

        return (
            <div className={classnames('flip-container', { flipped }, className)}>
                <div className="flipper" onDoubleClick={this.handleFlip}>
                    <div className="front">
                        {front}
                    </div>
                    <div className="back">
                        {back}
                    </div>
                </div>
            </div>
        );
    }
}

Flipper.propTypes = {
    className: PropTypes.string,
    front: PropTypes.any.isRequired,
    back: PropTypes.any.isRequired,
};

Flipper.defaultProps = {
    className: null,
};

export default Flipper;



// WEBPACK FOOTER //
// ./views/admin/about/index/Flipper.js